export default __webpack_public_path__ + "static/media/closeIconDisabled.2348eb77.svg";